export const States = [
  { name: "Ahafo", value: "Ahafo" },
  { name: "Ashanti", value: "Ashanti" },
  { name: "Bono", value: "Bono" },
  { name: "Bono East", value: "Bono East" },
  { name: "Central", value: "Central" },
  { name: "Eastern", value: "Eastern" },
  { name: "Greater Accra", value: "Greater Accra" },
  { name: "North East", value: "North East" },
  { name: "Northern", value: "Northern" },
  { name: "Oti", value: "Oti" },
  { name: "Savannah", value: "Savannah" },
  { name: "Upper East", value: "Upper East" },
  { name: "Upper West", value: "Upper West" },
  { name: "Volta", value: "Volta" },
  { name: "Western", value: "Western" },
  { name: "Western North", value: "Western North" },
];
